import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-stone-800 font-serif">
      {/* Navigation */}
      <nav className="bg-white shadow-md py-3">
        <div className="max-w-5xl mx-auto px-6 flex items-center justify-between">
          <Link to="/" className="font-sans font-semibold text-stone-800 tracking-wide text-sm">
            COMMUNICATE WITH INTELLIGENCE™
          </Link>
          <Link to="/" className="text-sm font-sans font-semibold text-amber-700 hover:text-amber-800 transition-colors">
            ← Back to Home
          </Link>
        </div>
      </nav>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <h1 className="text-3xl md:text-4xl font-bold text-stone-900 mb-4">Terms and Conditions</h1>
        <div className="h-1 w-16 bg-amber-600 mb-10" />

        <div className="space-y-8 text-stone-600 leading-relaxed">
          <p>
            The Communicate with Intelligence Program (CWIP) includes life-coaching and coursework related to discovering one's mission and agency in the world. Messages from CWIP include scheduling/rescheduling, confirmation/denial of appointments, reminders for meetings and appointments.
          </p>

          {/* SMS Cancellation */}
          <div>
            <h2 className="text-xl font-bold text-stone-900 mb-4 font-sans tracking-wide uppercase text-sm">
              SMS Cancellation
            </h2>
            <p>
              You can cancel the SMS service at any time. Simply text "STOP" to the shortcode. Upon sending "STOP," we will confirm your unsubscribe status via SMS. Following this confirmation, you will no longer receive SMS messages from us. To rejoin, sign up as you did initially, and we will resume sending SMS messages to you.
            </p>
          </div>

          {/* Support */}
          <div>
            <h2 className="text-xl font-bold text-stone-900 mb-4 font-sans tracking-wide uppercase text-sm">
              Support
            </h2>
            <p>
              If you experience issues with the messaging program, reply with the keyword HELP for more assistance, or reach out directly to{' '}
              <a href="mailto:mary@soul-full-living.com" className="text-amber-700 hover:text-amber-800 font-semibold transition-colors">
                mary@soul-full-living.com
              </a>{' '}
              or call{' '}
              <span className="font-semibold text-stone-800">855-499-0279</span>.
            </p>
          </div>

          {/* Carrier Liability */}
          <div>
            <h2 className="text-xl font-bold text-stone-900 mb-4 font-sans tracking-wide uppercase text-sm">
              Carrier Liability
            </h2>
            <p>
              Carriers are not liable for delayed or undelivered messages.
            </p>
          </div>

          {/* Message & Data Rates */}
          <div>
            <h2 className="text-xl font-bold text-stone-900 mb-4 font-sans tracking-wide uppercase text-sm">
              Message &amp; Data Rates
            </h2>
            <p>
              As always, message and data rates may apply for messages sent to you from us and to us from you. Message frequency varies. For questions about your text plan or data plan, contact your wireless provider.
            </p>
          </div>

          {/* Privacy */}
          <div className="bg-stone-50 rounded-lg p-8 mt-4">
            <h2 className="text-xl font-bold text-stone-900 mb-4 font-sans tracking-wide uppercase text-sm">
              Privacy
            </h2>
            <p>
              For privacy-related inquiries, please refer to our{' '}
              <Link to="/privacy" className="text-amber-700 hover:text-amber-800 font-semibold transition-colors">
                Privacy Policy
              </Link>.
            </p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="py-12 px-6 bg-stone-900 text-stone-400">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6 text-sm">
          <div className="text-center md:text-left">
            <p className="text-stone-300 font-sans font-semibold tracking-wide mb-1">
              COMMUNICATE WITH INTELLIGENCE™
            </p>
            <p>Soul-Full-Living LLC</p>
          </div>
          <div className="text-center md:text-right space-y-1">
            <p>
              <a href="mailto:mary@soul-full-living.com" className="hover:text-white transition-colors">
                mary@soul-full-living.com
              </a>
            </p>
            <p>855-499-0279</p>
          </div>
        </div>
        <div className="max-w-5xl mx-auto mt-8 pt-6 border-t border-stone-800 text-center text-xs text-stone-500">
          © {new Date().getFullYear()} Communicate with Intelligence — All Rights Reserved. &nbsp;
          <Link to="/privacy" className="hover:text-stone-300 transition-colors">Privacy Policy</Link>{' '}
          |{' '}
          <Link to="/terms" className="hover:text-stone-300 transition-colors">Terms and Conditions</Link>
        </div>
      </footer>
    </div>
  );
}
